import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { JOURNEY_STEPS, SELL_INTRO } from './salesData';

/**
 * OPORTUNIDAD. De la cocina al catálogo: el recorrido completo en cinco
 * pasos, cada uno con su imagen. Sin promesas de ingresos ni de ventas.
 */
export function SellSection() {
  return <section id="vender" className="scroll-mt-24 overflow-hidden bg-ivory py-14 sm:py-20" aria-labelledby="sell-title" data-id="element-324" data-mp="353az7y5l5h26">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-325" data-mp="1lsu3yh76o5g">
        <div className="max-w-3xl" data-id="element-326" data-mp="1l99ga05xlnq">
          <SectionTag data-id="element-327" data-mp="3j2tvntp1b3yn">Emprender desde casa</SectionTag>
          <h2 id="sell-title" className="mt-4 font-display text-[1.95rem] leading-[1.06] text-charcoal sm:text-[2.7rem]" data-id="element-328" data-mp="3j20v5ago5aoy">
            De tu cocina a tu propio catálogo de cookies
          </h2>
          <p className="mt-4 font-sans text-[0.95rem] leading-relaxed text-charcoal-mid" data-id="element-329" data-mp="fk0p40uobfdz">
            {SELL_INTRO}
          </p>
        </div>

        {/* Recorrido: aprendé → horneá → presentá → armá tu catálogo → ofrecé. */}
        <ol className="no-scrollbar mt-9 flex snap-x snap-mandatory gap-4 overflow-x-auto pb-2 sm:grid sm:grid-cols-3 sm:gap-5 sm:overflow-visible lg:grid-cols-5" data-id="element-330" data-mp="190q4tv01x054">
          {JOURNEY_STEPS.map(step => <motion.li key={step.id} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex w-[62%] shrink-0 snap-start flex-col overflow-hidden rounded-4xl bg-cream shadow-bakery-sm sm:w-auto" data-id="element-331" data-mp="1i0mn9evul2rq">
              <div className="relative" data-id="element-332" data-mp="21q6uikwae2xn">
                <img src={step.image} alt={step.alt} loading="lazy" decoding="async" className="aspect-[4/3] w-full object-cover" data-id="element-333" data-mp="21n185df1lf5m" />
                <span className="absolute left-3 top-3 flex h-7 w-7 items-center justify-center rounded-full bg-[#F47A2A] font-sans text-[0.6rem] font-bold tabular-nums text-white" data-id="element-334" data-mp="26ge6h2w46mjh">
                  {step.number}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4" data-id="element-335" data-mp="2gg5072cuoxii">
                <h3 className="font-display text-[1.05rem] leading-tight text-charcoal" data-id="element-336" data-mp="2ldmzs24za0du">
                  {step.title}
                </h3>
                <p className="mt-1.5 font-sans text-[0.82rem] leading-relaxed text-charcoal-mid" data-id="element-337" data-mp="2pcmbc5l7sve9">
                  {step.body}
                </p>
              </div>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}